<template>
  <div>
    <span class="caption font-weight-medium" v-if="label">
      {{ label }} <span class="error--text" v-if="required">*</span>
    </span>
    <v-select
      v-model="model"
      :prepend-inner-icon="icon"
      :items="items"
      :item-text="itemText"
      :rules="rules"
      :item-value="itemValue"
      :hide-details="hideDetails"
      :color="color"
      :clearable="clearable"
      :placeholder="placeholder"
      :return-object="returnObject"
      :disabled="disabled"
      dense
      :class="color === 'white' ? 'custom-field-white' : 'custom-field'"
      :multiple="multiple"
      solo
      flat
      filled
      @change="$emit('change')"
    >
    </v-select>
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  mixins: [hasModel],
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemText: {
      type: String,
      required: false,
      default: "text",
    },
    itemValue: {
      type: String,
      required: false,
      default: "value",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "primary",
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: "default",
    },
    returnObject: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    icon: {
      required: false,
      default: undefined,
    },
    hint: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
